import { Fragment } from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    TextInput,
    Filter,
    BulkExportButton,
} from 'react-admin';
import { List, ListActions } from '@react-admin/ra-enterprise';
import { CustomBreadcrumb } from './CustomBreadcrumb';
import CustomPagination from './CustomPagination';
import { makeStyles } from '@material-ui/core/styles';
import TransactionIdLink from './TransactionIdLink';
import TUserLink from './TUserLink';
import WithdrawStatus from './WithdrawStatus';


function idRoleAllow(resource_name, action_name) {
    let return_value = 'no';
    let login_role = localStorage.getItem('role');
    if (login_role == 'admin') {
        return 'ok';
    }
    let allpermission = JSON.parse(localStorage.getItem("roles"));
    let roledata = [];
    if (login_role == 'accountant') {
        roledata = allpermission.accountant;
    }
    if (login_role == 'auditor') {
        roledata = allpermission.auditor;
    }
    if (login_role == 'editor') {
        roledata = allpermission.editor;
    }
    roledata.map((role_row, index) => {
        if ((role_row.resource == resource_name) && (role_row.action.indexOf(action_name) > -1)) {
            console.log('operation ok');
            return_value = 'ok';
        }
    });
    return return_value;
}
const WithdrawalCommissionBulkActionButtons = ({ basePath }) => (
    <Fragment>
        {(idRoleAllow('pendingcommission', 'export') == 'ok') ?
            <BulkExportButton /> : ''}
    </Fragment>
);

const WithdrawalCommissionActions = (props) => (
    <ListActions  {...props} breadcrumb={<CustomBreadcrumb variant="actions" />} exporter={(idRoleAllow('pendingcommission', 'export') == 'ok') ? true : false} />
)

const WithdrawalCommissionFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Transaction Id" source="withdraw_id" defaultValue="" />
        <TextInput label="User name" source="user_name" defaultValue="" />
    </Filter>
);

const newStyle = makeStyles({
    tdcolor: { color: '#4f3cc9' }
});

const PendingCommission = (props) => {
    return (
        <List
            {...props}
            sort={{ field: 'created_at', order: 'DESC' }}
            actions={<WithdrawalCommissionActions />}
            filters={<WithdrawalCommissionFilter />}
            bulkActionButtons={<WithdrawalCommissionBulkActionButtons />}
            pagination={<CustomPagination />}
            title="Pending withdraw"            
        >
            <Datagrid>
                <TransactionIdLink source="withdraw_id" label="Transaction Id"/>
                <TUserLink source="user_name" label="User name" />
                <TextField source="withdraw_currency" label="Currency name" />
                <TextField source="withdraw_amount" label="Withdrawn" />
                <TextField source="withdraw_fee" label="Fee" />
                <TextField source="received_amount" label="Received" />
                <DateField source="created_at" label="Created at" showTime />
                <WithdrawStatus source="status" label="Status" />
            </Datagrid>
        </List>
    )
};
export default PendingCommission;